const InitialState = {
  lastCompanyCik: null,
  lastInvestorCik: null,
  lastViews: [],
};

const mutations = {
  setLastCompanyCik(state, data) {
    return Object.assign(state, { lastCompanyCik: data });
  },
  setLastInvestorCik(state, data) {
    return Object.assign(state, { lastInvestorCik: data });
  },
  setLastView(state, data) {
    return state.lastViews.push(data);
  },
};

const getters = {
  lastCompanyCik: (state) => state.lastCompanyCik,
  lastInvestorCik: (state) => state.lastInvestorCik,
  lastViews: (state) => state.lastViews,
};

export default {
  state: InitialState,
  mutations,
  getters,
  namespaced: true,
};
